import env from 'environments';
import { Authenticated } from 'modules/router/types';
import {
  ROUTE_HOMEPAGE,
  ROUTE_MAIL_ON_DEMAND,
  ROUTE_MAIL_ON_DEMAND_CREDITS,
  ROUTE_MAIL_ON_DEMAND_NEW,
  ROUTE_MAIL_ON_DEMAND_ORDER,
  ROUTE_MAIL_ON_DEMAND_RESUME,
} from './constants';

/**
 * The Mail on Demand (MOD) routes, mounted only while MAIL_ON_DEMAND_ENABLED
 * (`VITE_ENABLE_MOD` = exactly 'true', build-time). Hidden, every
 * `/mail-on-demand` URL (a bookmark, an old link) redirects to the dashboard
 * instead of opening the MOD pages.
 *
 * The pages are passed in rather than imported here: the real v2 route table
 * imports every page of the app and does not load under vitest, so this module
 * stays testable on its own.
 */
export const mailOnDemandRoutes = ({ OrdersPage, WizardPage, CreditsPage, OrderDetailPage }) => {
  if (!env.MAIL_ON_DEMAND_ENABLED) {
    return [{ path: ROUTE_MAIL_ON_DEMAND, redirect: ROUTE_HOMEPAGE }];
  }

  return [
    {
      type: Authenticated,
      exact: true,
      path: ROUTE_MAIL_ON_DEMAND,
      component: OrdersPage,
    },
    {
      type: Authenticated,
      exact: true,
      // One Route (and one mounted instance) for both wizard URLs: the wizard
      // history.replace()s from /new to /orders/:id/continue mid-flow, and two
      // separate Route entries would remount it, losing step state and the
      // in-flight submit (Phase 1.5 task 24).
      path: [ROUTE_MAIL_ON_DEMAND_NEW, ROUTE_MAIL_ON_DEMAND_RESUME],
      component: WizardPage,
    },
    {
      type: Authenticated,
      exact: true,
      path: ROUTE_MAIL_ON_DEMAND_CREDITS,
      component: CreditsPage,
    },
    {
      type: Authenticated,
      exact: true,
      path: ROUTE_MAIL_ON_DEMAND_ORDER,
      component: OrderDetailPage,
    },
  ];
};

export default mailOnDemandRoutes;
